import { Component, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-data-view',
  imports: [CommonModule],
  templateUrl: './fzhauptklasse.list-view.html',
  styleUrls: ['./fzhauptklasse.list-view.scss'],
})
export class FzhauptklasseListView implements FieldOkItemComponent<any> {
  @Input() item: any;

  constructor() {}
}
